import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material";
import { CreateStoreComponent } from '../create-store/create-store.component';
import { CommonService } from "../../_services/common.service";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Router, ActivatedRoute } from '@angular/router';
import { StoreProductPriceComponent } from '../store-product-price/store-product-price.component';
import { FlashMessagesService } from "angular2-flash-messages";
import { environment } from '../../../environments/environment';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
//import { ShippingInfoComponent } from '../../mnt-invoices/shipping-info/shipping-info.component';
import { PrintLabelComponent } from '../print-label/print-label.component';
import { CopyDialogComponent } from '../copy-dialog/copy-dialog.component';

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.css']
})
export class StoresComponent implements OnInit {
  tabList: any[];
  public loading = false;
  public storeList: Array<any> = [];
  public Options: any = {};
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 50;
  public search: string = "";
  public sortColumnName = "id";
  public sortDirection = "desc";
  public filterText: string;
  public storeStats: any = {};
  constructor(public dialog: MatDialog,
    private CommonService: CommonService,
    private CommonProjectDataService: CommonProjectDataService,
    private router: Router,
    private _flashMessagesService: FlashMessagesService

  ) {
    this.tabList = [

      { key: '/stores', val: 'Store', cls: 'active' },
      { key: '/stores/order', val: 'Order', cls: '' },
      { key: '/stores/archive-list', val: 'Archive', cls: '' }

    ]
  }

  ngOnInit() {
    this.getStoreData();
    //this.getStoreDetail();
    this.getStoreStats();
  }

  getStoreData = function () {
    this.loading = true;
    this.Options = {
      shop_id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page
    };
    if (this.filterText) {
      this.Options.search = this.filterText;
    }

    // if (this.sortDirection) {
    //   this.Options.orderBy = this.sortColumnName;
    //   this.Options.direction = this.sortDirection;
    // }
    this.CommonService.apiService(
      "POST",
      "store/list",
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.storeList = response.data.records;
            this.total=response.data.total;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  getStoreStats = function () {
    this.loading = true;
    this.Options = {
      id: localStorage.getItem("userID")
    }

    this.CommonService.apiService(
      "POST",
      "store/stats",
      this.Options
    ).subscribe(
      (response: any) => {
        //if (response.status === true) {
        this.loading = false;
        this.storeStats = response;        

        //}
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  openCreateStoreDialog(): void {

    const dialogRef = this.dialog.open(CreateStoreComponent, {
      width: "500px",
      disableClose: true,
      data: {
        storeData: null
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getStoreData();
      }
    });
  }
  openUpdateStoreDialog(id): void {
    let store = this.storeList.find(x => x.store_id == id);
    const dialogRef = this.dialog.open(CreateStoreComponent, {
      width: "500px",
      disableClose: true,
      data: {
        storeData: store
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getStoreData();
      }
    });
  }
  newOrder(storeId) {
    this.CommonProjectDataService.storeQuoteRequest(true);
    this.CommonProjectDataService.storeClientId(null);
    //this.CommonProjectDataService.storeStoreId(storeId);
    localStorage.setItem('storeId', storeId);
    localStorage.setItem('create_new_quote', 'true');
    localStorage.removeItem('pfMainFilters');
    this.router.navigate(["/quote/order"]);
  }
  viewQuote(id,orderType) {
    if(orderType=='Quote')
    {
      this.router.navigate(['/quote', { id: id }]);
    }
    if(orderType=='Invoice')
    {
      this.router.navigate(['/invoices', { id: id }]);
    }
   

}
  callAction(value) {
    if (value == 'createStore') {
      this.openCreateStoreDialog();
    }
  }
  
  openStorePriceDialog(storeId, orderId): void {
    this.loading = true;
    this.getProjectData(orderId)
    .then(projectData => {
      this.loading = false;
      const dialogRef = this.dialog.open(StoreProductPriceComponent, {
        width: "500px",
        data: {
          projects_data: projectData,
          storeId: storeId,
          quoteId: orderId,
          type: 'Update'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'success') {
          this._flashMessagesService.show("Record Saved successfully", {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      });
    })
    .catch(err => {
      this.loading = false;
      console.log(err);
    });
  }

  getProjectData = function (orderId): Promise<any> {
    return new Promise((resolve, reject) => {
      this.Options = {
        shop_id: localStorage.getItem("userID"),
        order_id: orderId
      };

      this.CommonService.apiService("POST", "store/projectdata", this.Options)
      .subscribe((response: any) => {
        if (response.status === true && response.data && response.data.projects_data) {
          resolve(response.data.projects_data);
        } else {
          reject("No project data found");
        }
      }, err => {
          reject(err);
      });
    });
  }

  viewStoreUrl(storeUrl) {
    let url = "https://" + storeUrl + '.' + environment.Store_URL;
    window.open(url, "_blank");
  }

  openDeleteDialog(storeId, index): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure they want to delete this store? If you proceed, all sales and invoices associated with the store will be permanently deleted. Would you like to proceed?",
        manageData: { store_id: storeId}
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.store_id) {
        const userName = prompt("Please enter your name to confirm:");
        
        if (userName) {
          this.deleteStore(result.store_id, userName, index);
        }
      }
    });

  }

  pushToProductionDialog(storeId: string): void {
    // Open a confirmation dialog
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: ", Are you sure you want to push this store to production?",
        message: "Confirming will create a batch order processing for products ordered from this store and create a clone for future order receiving at this store.",
        manageData: { store_id: storeId, dialogName: 'Push to Production' }
      }
    });
  
    // Subscribe to dialog close event
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.store_id) {
        this.pushToProductionStore(result.store_id);
      }
    });
  }

  pushToProductionStore = function (storeId: string) {
    const updateData = {
      'id': localStorage.getItem("userID"),
      'store_id': storeId
    };

    this.CommonService.apiService(
      "POST",
      "store/pushToProduction",
      updateData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show("This store has been successfully pushed to production.", {
            cssClass: "alert-success",
            timeout: 5000
          });

          // fetch all store lists and update store statistics.
          this.getStoreData();
          this.getStoreStats();
          window.scroll(0, 0);
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  };

  payLaterCheckoutCodeDialog(payLaterCode: string): void {
    // Open Pay Later Checkout Code Dialog
    const dialogRef = this.dialog.open(CopyDialogComponent, {
      width: "250px",
      data: {
        name: "Pay Later Checkout Code",
        data: { pay_later_code: payLaterCode }
      }
    });
  }


  deleteStore = function (store_id, userName, index) {
    this.Options = {};
    this.CommonService.apiService(
      "DELETE",
      "store/" + localStorage.getItem("userID") + "/" + store_id,
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show(`Dear ${userName}, your store has been deleted successfully!`, {
            cssClass: "alert-success",
            timeout: 5000
          });
          
          window.scroll(0, 0);
          this.storeList.splice(index, 1);
          //this.router.navigate(['/stores']);
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

  checkDate(endDate) {
    return new Date() > new Date(endDate) ? true : false;
  }
  viewCustomers(storeId) {
    this.router.navigate(['/stores/customer/' + storeId])
  }

  showShippingInfoDialog(storeId, orderId): void {
    const dialogRef = this.dialog.open(PrintLabelComponent, {

      disableClose: true,
      data: {
        store_id: storeId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {

      }
    });

  }

  removeString(name) {
    return name.replace('del_', '');
  }

  moveToAchive = function (storeId,index) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to archive this store",
        manageData: { store_id: storeId, dialogName: "Move to Archive" }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.store_id) {
        this.loading = true;
        this.Options = {
          id:result.store_id,
          shop_id: localStorage.getItem("userID")      
        };   
        this.CommonService.apiService(
          "POST",
          "store/movetoarchive",
          this.Options
        ).subscribe(
          (response: any) => {
            if (response.status === true) {
              this.loading = false;
              this.storeList.splice(index,1);         
            }
          },
          err => {
            this.loading = false;
            console.log(err);
          }
        );
      }
    });
  }
  goToPage(n: number): void {
    this.page = n;
    this.getStoreData();
  }

  onNext(): void {
    this.page++;
    this.getStoreData();
  }

  onPrev(): void {
    this.page--;
    this.getStoreData();
  } 

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/stores/stores.component.ts